import { createContext, ReactNode } from 'react';

import useSac from './hooks/useSac';
import useHome from './hooks/useHome';
import useMyPerfil from './hooks/useMyPerfil';
import usePayments from './hooks/usePayments';
import useExchanges from './hooks/useExchanges';
import useScheduling from './hooks/useScheduling';
import useMyVehicles from './hooks/useMyVehicles';
import useShoppingCart from './hooks/useShoppingCart';
import useEquipmentTest from './hooks/useEquipmentTest';
import useAuthentication from './hooks/useAuthentication';
import useRegisterValidation from './hooks/useRegisterValidation';
import useAdditionalServices from './hooks/useAdditionalServices';
import useShoppingCartuseAddServices from './hooks/useShoppingCartuseAddServices';

import * as Type from 'utils/typeServices';

type DataContextProps = {
    children: ReactNode;
}

type Params = {
    //useRegisterValidation
    dataFormAddress?: Type.ParamsDataAddress;
    dataFormPersonal?: Type.ParamsDataSearchPersonal;
    dataResendToken?: Type.ParamsDataValidatePersonalData | false;
    dataSearchPersonData?: Type.RegistrationValidation | false | null;
    dataUpdatePersonalData?: Type.ParamsDataUpdatePersonalData | false;
    dataValidatePersonalData?: Type.ParamsDataValidatePersonalData | false | null;
    handleUpdateFormAddress: (body: Type.ParamsDataAddress) => void;
    handlePostResendToken: (body: Type.ParamsBodyValidatePersonalData) => void;
    handleUpdateFormPersonal: (body: Type.ParamsDataSearchPersonal) => void;
    handleGetSearchPersonData: (body: Type.ParamsBodySearchPersonal) => void;
    handlePutUpdatePersonalData: (body: Type.ParamsBodyUpdatePersonalData) => void;
    handlePostValidatePersonalData: (body: Type.ParamsBodyValidatePersonalData) => void;
    //useMyVehicles
    dataUpdatePlate?: Type.ParamsDataUpdatePlate;
    dataUsefulContacts?: Type.ParamsDataUsefulContacts;
    handleGetUsefulContacts: ({ token }: { token: string }) => void;
    handlePostUpdatePlate: ({ token }: { token: string, body: Type.ParamsBodyUpdatePlate }) => void;
    //useShoppingCart
    dataProductCart: Type.ParamsDataProductCart;
    dataChooseQuoteItems?: Type.ParamsDataChooseQuoteItems;
    handlePostChooseQuoteItems: () => void;
    handleParseProductCart: ({ body }: { body: Type.ParamsBodyParseProductCart }) => void;
    handleProductCart: ({ bodyBase, body, addProduct, productPlan }: { bodyBase: Type.ParamsBodyCartState, body: Type.ParamsProduct, addProduct: boolean, productPlan: boolean }) => void;
    //useSac
    dataFormFaleConosco?: boolean;
    dataFaq?: Array<Type.ParamsDataFaq>;
    dataCustomerForRequest?: Type.ParamsDataCustomerForRequest;
    handleClearSac: () => void;
    handleGetFaq: ({ token }: { token: string }) => void;
    handleGetCustomerForRequest: ({ token }: { token: string }) => void;
    handlePostFormFaleConosco: ({ body }: { body: Type.ParamsBodyFormFaleConosco }) => void;
    //useHome
    photoCustomer: any;
    blockClick: boolean;
    isViewModal: boolean;
    selectedCar?: Type.ParamsCustomerCars;
    customerCars: Array<Type.ParamsCustomerCars>;
    customerCard?: Type.ParamsPersonalCardByPlatform;
    dataGetPlatformRemoval?: Array<Type.ParamsDataGetPlatformRemoval>;
    dataGetVirtualFencesHistory?: Type.ParamsDataGetVirtualFencesHistory;
    dataFitClientScheduling?: Array<Type.ParamsDataGetFitClientScheduling>;
    handleIsViewModal: () => void;
    handleClearSchedulingHome: () => void;
    handleGetUrlAdvantagesClub: () => void;
    handleSelectedCar: (data: Type.ParamsCustomerCars) => void;
    handleGetInitialServices: ({ token, isWebView }: { token: string, isWebView?: boolean }) => void;
    handlePostSavePhoto: ({ token, body }: { token: string, body: Type.ParamsBodySavePhoto }) => void;
    handlePostGetVirtualFencesHistory: ({ body }: { body: Type.ParamsBodyGetVirtualFencesHistory }) => void;
    //useScheduling
    dataEffectSchedule?: boolean;
    dataBuscaTermoDeAdesao?: boolean;
    dataOrdersByCustomerId?: Array<Type.ParamsDataOrdersByCustomerId>;
    dataGenerateReschedulingFee?: Type.ParamsDataGenerateReschedulingFee;
    dataOrderDetailScheduling?: Type.ParamsDataOrderDetailScheduling | false | null;
    dataListStoresByZipCode?: Array<Type.ParamsDataListStoresByZipCode> | false;
    handleClearScheduling: () => void;
    handleGetOrdersByCustomerId: ({ token }: { token: string }) => void;
    handleGetOrderDetailScheduling: ({ token, cdPedido }: { token: string, cdPedido: string }) => void;
    handlePostBuscaTermoDeAdesao: ({ token, CD_AGENDAMENTO }: { token: string, CD_AGENDAMENTO: number }) => void;
    handlePostGetListStoresByZipCode: ({ token, body }: { token: string, body: Type.ParamsBodyGetListStoresByZipCode }) => void;
    handlePostEffectSchedule: ({ token, body, isExchanges, isWebView }: { token: string, body: Type.ParamsBodyEffectSchedule, isExchanges?: boolean, isWebView: boolean }) => void;
    handlePostAgendamentoDesinstalacao: ({ token, body, NR_PLATAFORMA }: { token: string, body: Type.ParamsBodyEffectSchedule, NR_PLATAFORMA: number }) => void;
    //useAuthentication
    dataSendToken?: boolean;
    isShowModalAlert: boolean;
    isLoadingBanner: boolean;
    activeLoginBanner: string | null;
    dataUpdatePassword?: boolean;
    dataCreateLoginApp?: boolean | string;
    errorLogin: Type.ParamsErrorLogin;
    dataValidatePasswordToken?: boolean;
    dataValidateDocument?: Type.ParamsDataUserFound;
    dataTokenExternal?: Type.ParamsDataAuthenticationExternal | false;
    dataUserAccountPassword?: Type.ParamsDataUserAccountPassword | false;
    handleClearAuthentication: () => void;
    handleAlertModal: (body: boolean) => void;
    handleGetActiveLoginBanner: () => void;
    handlePostGetContacts: (body: string) => void;
    handlePostValidateEmailLogin: (body: string) => void;
    handlePostAuthenticationClientCredentials: () => void;
    handlePostSendToken: (body: Type.ParamsBodyPostSendToken) => void;
    handlePostAuthentication: (body: Type.ParamsBodyAuthentication) => void;
    handlePostValidateDocument: (body: Type.ParamsBodyValidateDocument) => void;
    handlePostUpdatePassword: (body: Type.ParamsBodyPostUpdatePassword) => void;
    handlePostCreateLoginApp: (body: Type.ParamsBodyPostCreateLoginApp) => void;
    handlePostValidatePasswordToken: (body: Type.ParamsBodyPostValidatePasswordToken) => void;
    handlePostObtainUserLogin: (body: Type.ParamsBodyObtainUserLogin, sendObtainUser: boolean) => void;
    //useMyPerfil
    updatePerfil?: Type.ParamsUpdatePerfil;
    dataByZipCode?: Type.ParamsBodyByZipCode | false;
    dataPerfilUser?: Type.ParamsDataPerfilUser | false;
    dataCustomerForEdit?: Type.ParamsDataCustomerForEdit;
    dataRelationship?: Array<Type.ParamsDataGetRelationship>;
    dataPolicyPdfRequest?: Type.ParamsDataPolicyPdfRequest | false;
    dataPlatformsWithPolicy?: Array<Type.ParamsDataPlatformsWithPolicy> | false;
    handleResetUpdatePerfil: () => void;
    handleGetRelationship: ({ token }: { token: string }) => void;
    handleGetCustomerForEdit: ({ token }: { token: string }) => void;
    handleGetPlatformsWithPolicy: ({ token }: { token: string }) => void;
    handleGetByZipCode: ({ token, cep, indexId }: { token: string, cep: string, indexId?: number }) => void;
    handleGetPerfilUser: ({ token, nrPlatform }: { token: string, nrPlatform: number }) => void;
    handlePostPolicyPdfRequest: ({ token, body }: { token: string, body: Type.ParamsBodyPolicyPdfRequest }) => void;
    handlePostEditCustomerAppData: ({ token, body }: { token: string, body: Type.ParamsBodyEditCustomerAppData }) => void;
    handlePostEditCustomerAppPhone: ({ token, body }: { token: string, body: Type.ParamsBodyEditCustomerAppPhone }) => void;
    handlePostEditCustomerAppAccess: ({ token, body }: { token: string, body: Type.ParamsBodyEditCustomerAppAccess }) => void;
    handlePostEditCustomerAppAddress: ({ token, body }: { token: string, body: Type.ParamsBodyEditCustomerAppAddress }) => void;
    handlePostEditCustomerAppEmergencyContacts: ({ token, body }: { token: string, body: Type.ParamsBodyEditCustomerAppEmergencyContacts }) => void;
    //useExchanges
    dataCar?: Type.ParamsDataCar;
    dataPostCancelChange?: boolean;
    dataPostCancelChangeOwnerSolicitation?: boolean;
    dataGetChangeSolicitation?: any | false;
    formDataPerfil?: Type.FormDataPerfil;
    sucessChangeSolicitationPlatform?: boolean;
    isFormCar?: boolean | Array<Type.ParamsVersion>;
    dataValidateChoose?: Type.ParamsDataValidateChoose;
    dataGetListarCotacoes?: Type.ParamsDataGetStatus;
    dataCreateChangeSolicitation?: { cD_SOLICITACAO: number; success?: boolean; } | false;
    dataListarCotacoes?: Array<Type.ParamsDataGetListarCotacoes> | false;
    dataQuoteListservices?: Type.ParamsDataPostQuoteListservices | false;
    dataObterDadosCorretorPorPedido?: Type.ParamsDataPostObterDadosCorretorPorPedido | false;
    handleClearExchanges: () => void;
    handleClearDataValidateChoose: () => void;
    dataVehicleTypeMismatch?: string;
    handleClearVehicleTypeMismatch: () => void;
    handleErrorTicketOpen: (showError: boolean) => void;
    handleGetListarCotacoes: (CPF_CNPJ: string) => void;
    handlePostCancelChange: (body: Type.ParamsBodyPostCancelChange) => void;
    handlePostCancelChangeOwnerSolicitation: (body: Type.ParamsBodyChangeSolicitation) => void;
    handleGetChangeSolicitation: ({ body }: { body: Type.ParamsBodyChangeSolicitation }) => void;
    handleSearchCar: ({ typeDetailsCar, codDetailCar }: Type.ParamsPayloadCartDetails) => void;
    handlePostGetStatus: ({ body, isWebView }: { body: Type.ParamsBodyPostGetStatus, isWebView: boolean }) => Promise<Type.ParamsDataGetStatus | null>;
    handlePostQuotePlatform: ({ body, isWebView }: { body: Type.ParamsBodyPostQuotePlatform, isWebView: boolean }) => void;
    handleFormDataPerfil: ({ body, sameProfile }: Type.handleBodyFormDataPerfil) => void;
    handlePostQuoteListservices: ({ body, isWebView }: { body: Type.ParamsBodyPostQuoteListservices, isWebView: boolean }) => void;
    handlePostObterDadosCorretorPorPedido: (body: Type.ParamsBodyPostObterDadosCorretorPorPedido) => void;
    handlePostCreateChangeSolicitation: ({ body }: { body: Type.ParamsBodyPostCreateChangeSolicitation }) => void;
    handlePostValidateChoose: ({ body, bodyCart, isWebView }: { body: Type.ParamsBodyValidateChoose, bodyCart: Type.ParamsBodyCart, isWebView: boolean }) => void;
    handlePostCreateChangeSolicitationPlatform: ({ body }: { body: Type.ParamsBodyCreateChangeSolicitationPlatform, bodyChooseQuoteItems: Type.ParamsBodyChooseQuoteItems }) => void;
    //usePayments
    isPendingTicket?: boolean;
    serviceTerms?: HTMLElement;
    dataErrorTicketOpen?: boolean;
    dataChangeBillingPaymentMethod?: any | false;
    dataChangeBillingPaymentDueDate?: any | false;
    listPaymentAvailable?: Array<Type.ParamsBank>;
    invoicesCustomer: Array<Type.ParamsCustomerCharges>;
    customerPaymentForms?: Array<Type.ParamsPaymentForms>;
    formOfPayment?: Array<Type.ParamsPaymentFormsInitial>;
    dataConfirmOrder?: Type.ParamsDataConfirmOrder | false;
    dataGerarCobranca?: Type.ParamsDataGerarCobranca | false;
    dataGenerateBillingPix?: Type.ParamsDataGenerateBillingPix;
    dataGenerateBillingTicket?: Type.ParamsDataGenerateBillingTicket;
    dataValidateSolicitationDate?: Type.ParamsDataValidateSolicitationDate | false;
    dataFinancialPending?: Array<Type.ParamsDataFinancialPending> | false | string;
    dataGetPaymentTicketScheduling?: Type.ParamsDataGenerateBillingTicket | false;
    dataListarFormaPagamentoPorCanalVenda?: Array<Type.ParamsDataListarFormaPagamentoPorCanalVenda>;
    handleClearPayments: () => void;
    handleDataGerarCobranca: () => void;
    handleGetPaymentForms: ({ token }: { token: string }) => void;
    handleGetServiceTerms: ({ token, type }: { token: string, type: number }) => void;
    handleGetPaymentAvailable: ({ token, type }: { token: string, type: number }) => void;
    handleGetCustomerCharges: ({ token, nrPlatform }: { token: string, nrPlatform: number }) => void;
    handlePostValidateSolicitationDate: ({ body }: { body: Type.ParamsValidateSolicitationDate }) => void;
    handlePostGerarCobranca: ({ token, body }: { token: string, body: Type.ParamsBodyGerarCobranca }) => void;
    handlePostPaymentSlipApp: ({ token, body }: { token: string, body: Type.ParamsBodyPaymentSlipApp }) => void;
    handleGetBillingsByCustomerId: ({ token, pendingTicket }: { token: string, pendingTicket?: boolean }) => void;
    handlePostChangeBillingPaymentDueDate: ({ body }: { body: Type.ParamsBodyChangeBillingPaymentDueDate }) => void;
    handlePostConfirmOrder: ({ body, isWebView }: { body: Type.ParamsBodyConfirmOrder, isWebView?: boolean }) => void;
    handlePostFinancialPending: ({ token, body }: { token: string | null, body: Type.ParamsBodyFinancialPending }) => void;
    handleAcceptTermo: () => void;
    handlePostAcceptTerm: ({ token, body }: { token: string | null, body: Type.ParamsBodyAcceptTerm }) => Promise<any>;
    handlePostChangeBillingPaymentMethod: ({ token, body }: { token: string, body: Type.ParamsBodyChangeBillingPaymentMethod }) => void;
    handlePostGenerateBilling: ({ token, body, type }: { token: string, body: Type.ParamsGenerateBilling, type: 'ticket' | 'pix' | 'email' }) => void;
    handlePostListarFormaPagamentoPorCanalVenda: ({ token, body }: { token: string, body: Type.ParamsBodyListarFormaPagamentoPorCanalVenda }) => void;
    handleGetPaymentTicketScheduling: ({ CD_COBRANCA_TAXA_REAGENDAMENTO, body }: { CD_COBRANCA_TAXA_REAGENDAMENTO: number, body: Type.ParamsBodyFinancialPending }) => void;
    //usePostEquipmentTest
    dataEquipmentTest?: boolean | number;
    handleClearEquipmentTest: () => void;
    handleGetEquipmentTest: (nrPLataforma: number) => void;
    //useAdditionalServices
    isFormCarAddService?: boolean | Array<Type.ParamsVersion>;
    dataListQuoteAdd?: Type.ParamsDataPostCreateQuote | false;
    dataListActiveProducts?: Array<Type.ParamsDataActiveProduct> | false;
    dataListaCotacaoAddService?: Array<Type.ParamsDataListaCotacaoAddService> | false;
    handleGetListaCotacaoAddService: (CPF_CNPJ: string) => void;
    handlePostCreateQuote: ({ bodyLead, bodyQuote, nrPlatform }: { bodyLead: Type.ParamsBodyPostCreateLead, bodyQuote: Type.ParamsBodyPostCreateQuote, nrPlatform: number }) => void;
    //useShoppingCartAddServices
    dataCreateOrder?: Type.ParamsDataPostCreateOrder | false;
    dataGetListarCotacoesAddService?: Type.ParamsDataGetStatus;
    dataProductCartAddServices: Type.ParamsDataProductCartAddServices;
    dataChooseQuoteItemsAddServices?: Type.ParamsDataPostUpdateQuote | false;
    handlePostCreateOrderAddServices: (body: Type.ParamsBodyPostCreateOrder, isWebView: boolean) => void;
    handleParseProductCartAddServices: ({ body }: { body: Type.ParamsBodyParseProductCart }) => void;
    handlePostGetStatusAddService: ({ body, isWebView, nrPlatform }: { body: Type.ParamsBodyPostGetStatus, isWebView: boolean, nrPlatform: number }) => void;
    handleProductCartAddServices: ({ bodyBase, body, addProduct }: { bodyBase: Type.ParamsBodyCartState, body: Type.ParamsProduct, addProduct: boolean }) => void;
    handlePostChooseQuoteItemsAddServices: ({ CD_CANAL_VENDA, CD_COTACAO, CD_PESSOA_PARCEIRO, CD_PESSOA_PARCEIRO_ESTABELECIMENTO, CD_PESSOA_VENDEDOR }: Type.ParamsBodyFilterPostUpdateQuote, isWebView: boolean) => void;
    //logout
    handleClearLogout: () => void;
}

export const DataContext = createContext({} as Params);

export const DataProvider = ({ children }: DataContextProps) => {
    const { dataSearchPersonData, dataFormAddress, dataFormPersonal, dataUpdatePersonalData, dataValidatePersonalData, dataResendToken, handleGetSearchPersonData, handleUpdateFormAddress, handlePostValidatePersonalData, handlePutUpdatePersonalData, handlePostResendToken, handleUpdateFormPersonal } = useRegisterValidation();
    const { dataEquipmentTest, handleGetEquipmentTest, handleClearEquipmentTest } = useEquipmentTest();
    const { dataUsefulContacts, dataUpdatePlate, handleGetUsefulContacts, handlePostUpdatePlate, handleClearVehicles } = useMyVehicles();
    const { dataProductCart, dataChooseQuoteItems, handleProductCart, handlePostChooseQuoteItems, handleClearShoppingCart, handleParseProductCart } = useShoppingCart();
    const { dataFaq, dataCustomerForRequest, dataFormFaleConosco, handleGetCustomerForRequest, handleGetFaq, handlePostFormFaleConosco, handleClearSac } = useSac();
    const { selectedCar, customerCars, customerCard, photoCustomer, dataGetPlatformRemoval, isViewModal, blockClick, dataGetVirtualFencesHistory, dataFitClientScheduling, handleSelectedCar, handleGetInitialServices, handlePostSavePhoto, handleClearHome, handleIsViewModal, handlePostGetVirtualFencesHistory, handleGetUrlAdvantagesClub, handleClearSchedulingHome } = useHome();
    const { dataOrdersByCustomerId, dataOrderDetailScheduling, dataListStoresByZipCode, dataEffectSchedule, dataGenerateReschedulingFee, dataBuscaTermoDeAdesao, handleGetOrderDetailScheduling, handlePostGetListStoresByZipCode, handleGetOrdersByCustomerId, handlePostEffectSchedule, handleClearScheduling, handlePostAgendamentoDesinstalacao, handlePostBuscaTermoDeAdesao } = useScheduling();
    const { dataCustomerForEdit, dataPerfilUser, dataByZipCode, dataRelationship, dataPlatformsWithPolicy, updatePerfil, dataPolicyPdfRequest, handleGetCustomerForEdit, handleGetPerfilUser, handlePostEditCustomerAppData, handlePostEditCustomerAppAccess, handlePostEditCustomerAppPhone, handleGetByZipCode, handlePostEditCustomerAppAddress, handleGetRelationship, handlePostEditCustomerAppEmergencyContacts, handleGetPlatformsWithPolicy, handleClearPerfil, handleResetUpdatePerfil, handlePostPolicyPdfRequest } = useMyPerfil();
    const { errorLogin, dataValidateDocument, dataUserAccountPassword, dataSendToken, dataValidatePasswordToken, dataUpdatePassword, dataCreateLoginApp, isShowModalAlert, isLoadingBanner, activeLoginBanner, dataTokenExternal, handlePostAuthentication, handlePostValidateDocument, handlePostObtainUserLogin, handlePostValidateEmailLogin, handlePostSendToken, handlePostValidatePasswordToken, handlePostUpdatePassword, handlePostGetContacts, handlePostCreateLoginApp, handleClearAuthentication, handleAlertModal, handleGetActiveLoginBanner, handlePostAuthenticationClientCredentials } = useAuthentication();
    const { formDataPerfil, dataQuoteListservices, dataValidateChoose, dataCreateChangeSolicitation, dataGetChangeSolicitation, dataListarCotacoes, sucessChangeSolicitationPlatform, dataObterDadosCorretorPorPedido, dataGetListarCotacoes, dataPostCancelChange, dataPostCancelChangeOwnerSolicitation, dataErrorTicketOpen, dataCar, isFormCar, dataVehicleTypeMismatch, handleFormDataPerfil, handlePostQuoteListservices, handlePostCreateChangeSolicitation, handleGetChangeSolicitation, handlePostValidateChoose, handleGetListarCotacoes, handlePostGetStatus, handlePostQuotePlatform, handlePostCreateChangeSolicitationPlatform, handlePostObterDadosCorretorPorPedido, handleClearExchanges, handleClearDataValidateChoose, handleClearVehicleTypeMismatch, handlePostCancelChange, handlePostCancelChangeOwnerSolicitation, handleErrorTicketOpen, handleSearchCar } = useExchanges();
    const { dataChangeBillingPaymentDueDate, invoicesCustomer, customerPaymentForms, listPaymentAvailable, serviceTerms, dataFinancialPending, dataGenerateBillingPix, dataGenerateBillingTicket, dataListarFormaPagamentoPorCanalVenda, dataGerarCobranca, dataChangeBillingPaymentMethod, dataConfirmOrder, formOfPayment, dataGetPaymentTicketScheduling, isPendingTicket, dataValidateSolicitationDate, handleGetCustomerCharges, handleGetPaymentForms, handleGetPaymentAvailable, handleGetServiceTerms, handlePostPaymentSlipApp, handlePostFinancialPending, handlePostGenerateBilling, handlePostChangeBillingPaymentMethod, handlePostListarFormaPagamentoPorCanalVenda, handlePostGerarCobranca, handleClearPayments, handlePostConfirmOrder, handlePostChangeBillingPaymentDueDate, handleGetBillingsByCustomerId, handleGetPaymentTicketScheduling, handleDataGerarCobranca, handlePostValidateSolicitationDate, handleAcceptTermo, handlePostAcceptTerm } = usePayments();
    const { dataListQuoteAdd, dataListaCotacaoAddService, dataListActiveProducts, dataGetListarCotacoesAddService, isFormCarAddService, handlePostCreateQuote, handleGetListaCotacaoAddService, handleClearAdditionalServices, handlePostGetStatusAddService } = useAdditionalServices();
    const { dataProductCartAddServices, dataChooseQuoteItemsAddServices, dataCreateOrder, handleParseProductCartAddServices, handlePostChooseQuoteItemsAddServices, handleProductCartAddServices, handleClearShoppingCartAddServices, handlePostCreateOrderAddServices } = useShoppingCartuseAddServices();

    const handleClearLogout = () => {
        handleClearVehicles();
        handleClearShoppingCart();
        handleClearSac();
        handleClearHome();
        handleClearScheduling();
        handleClearPerfil();
        handleClearExchanges();
        handleClearPayments();
        handleClearEquipmentTest();
        handleClearAuthentication();
        handleClearAdditionalServices();
        handleClearShoppingCartAddServices();
    }

    return (
        <DataContext.Provider value={{
            dataFaq,
            dataCar,
            isFormCar,
            blockClick,
            errorLogin,
            isViewModal,
            selectedCar,
            updatePerfil,
            customerCars,
            serviceTerms,
            customerCard,
            formOfPayment,
            dataSendToken,
            photoCustomer,
            dataByZipCode,
            formDataPerfil,
            dataPerfilUser,
            dataResendToken,
            dataCreateOrder,
            isPendingTicket,
            dataUpdatePlate,
            dataProductCart,
            dataFormAddress,
            dataFormPersonal,
            isShowModalAlert,
            isLoadingBanner,
            activeLoginBanner,
            dataConfirmOrder,
            dataRelationship,
            invoicesCustomer,
            dataListQuoteAdd,
            dataTokenExternal,
            dataEquipmentTest,
            dataGerarCobranca,
            dataListarCotacoes,
            dataUsefulContacts,
            dataEffectSchedule,
            dataUpdatePassword,
            dataValidateChoose,
            dataCreateLoginApp,
            isFormCarAddService,
            dataErrorTicketOpen,
            dataFormFaleConosco,
            dataCustomerForEdit,
            dataGetListarCotacoes,
            customerPaymentForms,
            dataValidateDocument,
            dataPolicyPdfRequest,
            listPaymentAvailable,
            dataFinancialPending,
            dataChooseQuoteItems,
            dataSearchPersonData,
            dataPostCancelChange,
            dataPostCancelChangeOwnerSolicitation,
            dataGetChangeSolicitation,
            dataQuoteListservices,
            dataUpdatePersonalData,
            dataBuscaTermoDeAdesao,
            dataOrdersByCustomerId,
            dataCustomerForRequest,
            dataGenerateBillingPix,
            dataGetPlatformRemoval,
            dataListActiveProducts,
            dataListStoresByZipCode,
            dataUserAccountPassword,
            dataFitClientScheduling,
            dataPlatformsWithPolicy,
            dataValidatePersonalData,
            dataOrderDetailScheduling,
            dataGenerateBillingTicket,
            dataValidatePasswordToken,
            dataProductCartAddServices,
            dataGenerateReschedulingFee,
            dataGetVirtualFencesHistory,
            dataValidateSolicitationDate,
            dataCreateChangeSolicitation,
            dataListaCotacaoAddService,
            dataChangeBillingPaymentMethod,
            dataGetPaymentTicketScheduling,
            dataGetListarCotacoesAddService,
            dataObterDadosCorretorPorPedido,
            dataChangeBillingPaymentDueDate,
            dataChooseQuoteItemsAddServices,
            sucessChangeSolicitationPlatform,
            dataListarFormaPagamentoPorCanalVenda,
            handleGetFaq,
            handleClearSac,
            handleSearchCar,
            handleAlertModal,
            handleGetActiveLoginBanner,
            handleProductCart,
            handleSelectedCar,
            handleClearLogout,
            handleIsViewModal,
            handleGetByZipCode,
            handlePostGetStatus,
            handleGetPerfilUser,
            handlePostSendToken,
            handlePostSavePhoto,
            handleClearPayments,
            handleFormDataPerfil,
            handleClearExchanges,
            handleClearDataValidateChoose,
            dataVehicleTypeMismatch,
            handleClearVehicleTypeMismatch,
            handlePostGetContacts,
            handleClearScheduling,
            handlePostUpdatePlate,
            handleGetRelationship,
            handleGetServiceTerms,
            handleGetPaymentForms,
            handleErrorTicketOpen,
            handlePostCreateQuote,
            handlePostCancelChange,
            handlePostCancelChangeOwnerSolicitation,
            handleGetChangeSolicitation,
            handleParseProductCart,
            handlePostConfirmOrder,
            handlePostResendToken,
            handleGetEquipmentTest,
            handleGetListarCotacoes,
            handlePostQuotePlatform,
            handleGetUsefulContacts,
            handleDataGerarCobranca,
            handlePostGerarCobranca,
            handleResetUpdatePerfil,
            handleUpdateFormAddress,
            handleUpdateFormPersonal,
            handleGetCustomerForEdit,
            handlePostCreateLoginApp,
            handleClearEquipmentTest,
            handlePostAuthentication,
            handlePostPaymentSlipApp,
            handleGetCustomerCharges,
            handleGetInitialServices,
            handlePostUpdatePassword,
            handlePostValidateChoose,
            handlePostEffectSchedule,
            handleClearSchedulingHome,
            handlePostFormFaleConosco,
            handlePostGenerateBilling,
            handleGetSearchPersonData,
            handlePostObtainUserLogin,
            handleGetPaymentAvailable,
            handleClearAuthentication,
            handleGetUrlAdvantagesClub,
            handlePostFinancialPending,
            handleAcceptTermo,
            handlePostAcceptTerm,
            handlePostChooseQuoteItems,
            handlePostValidateDocument,
            handlePutUpdatePersonalData,
            handlePostPolicyPdfRequest,
            handlePostQuoteListservices,
            handleGetOrdersByCustomerId,
            handleGetCustomerForRequest,
            handlePostBuscaTermoDeAdesao,
            handleProductCartAddServices,
            handleGetPlatformsWithPolicy,
            handlePostValidateEmailLogin,
            handleGetBillingsByCustomerId,
            handlePostEditCustomerAppData,
            handlePostGetStatusAddService,
            handleGetOrderDetailScheduling,
            handlePostValidatePersonalData,
            handlePostEditCustomerAppPhone,
            handleGetListaCotacaoAddService,
            handlePostEditCustomerAppAccess,
            handlePostValidatePasswordToken,
            handlePostCreateOrderAddServices,
            handlePostGetListStoresByZipCode,
            handlePostEditCustomerAppAddress,
            handleGetPaymentTicketScheduling,
            handleParseProductCartAddServices,
            handlePostGetVirtualFencesHistory,
            handlePostValidateSolicitationDate,
            handlePostCreateChangeSolicitation,
            handlePostAgendamentoDesinstalacao,
            handlePostChangeBillingPaymentMethod,
            handlePostChooseQuoteItemsAddServices,
            handlePostObterDadosCorretorPorPedido,
            handlePostChangeBillingPaymentDueDate,
            handlePostAuthenticationClientCredentials,
            handlePostCreateChangeSolicitationPlatform,
            handlePostEditCustomerAppEmergencyContacts,
            handlePostListarFormaPagamentoPorCanalVenda
        }}>
            {children}
        </DataContext.Provider>
    )
}